import OrderService from 'respona_api/generated/order-concierge_pb_service';

const service = (function () {
  let instance = null;

  return {
    getInstance: (): OrderService.OrderConciergeApiServiceClient => {
      if (!instance) {
        // @ts-ignore
        instance = new OrderService.OrderConciergeApiServiceClient(API_HOST);
      }

      return instance;
    },
  };
})();

export default service;
